<template>
<v-card >
  <request-status :request='request' @ok='$emit("success")' />

  <v-card-text>
    <v-row>
      <v-col cols="6" >
        <v-card-title class="overline" >Choose appointment types to copy</v-card-title>
        <hierarchical-picker multiple
          :fixed-space="fixedSpace"
          :space-id="spaceId"
          @update:products="setProducts" />
      </v-col>
      <v-col cols="6" >
        <v-card height="100%" class="grey lighten-5 elevation-5" >
          <v-card-title class='subtitle-1 overline' >
            Copy {{products.length}} products to: {{practitioner.full_name}}, {{space.title}}
          </v-card-title>
          <v-card-text>
            <strong>Which locations?</strong>
            <v-chip-group multiple column
              v-model="locations"
              active-class="primary" >
              <v-chip filter
                v-for="loc in space.locations"
                :value="loc.id"
                :key="loc.id" >{{loc.name}}</v-chip>
            </v-chip-group>
            <!-- {{locations}} -->
          </v-card-text>
          <v-card-actions >
            <v-spacer/>
            <v-btn color="primary"
              @click="save"
              :disabled="!isValid" >Copy Appointment Types</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>

  <!-- <pre v-text="space" class="caption grey lighten-4 pa-3" /> -->
</v-card>
</template>
<script>
import HierarchicalPicker from '@/components/pickers/HierarchicalPicker.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CopyProducts',
  components: {HierarchicalPicker},
  props: {
    spaceId: { required: true },
    practitionerId: { required: true }, // the practitioner onto which to copy items
    fixedSpace: { type: Boolean, default: false } // don't let the user pick a space
  },
  data () {
    return {
      products: [],
      locations: [],
      request: {
        resource: 'ag.practitioner',
        extra: 'actions/copy_products',
        method: 'post'
      }
    }
  },
  methods: {
    setProducts (products) {
      this.products = products
    },
    save () {
      this.request.resourceId = this.meId
      this.request.data = this.payload
      this.$request('save', this.request)
    }
  },
  computed: {
    ...mapGetters ('identity', ['meId', 'getSpaceById', 'getPractitionerById']),
    space () {
      if (this.spaceId) {
        return this.getSpaceById(this.spaceId)
      }
      return {}
    },
    practitioner () {
      if (this.practitionerId) {
        return this.getPractitionerById(this.practitionerId)
      }
      return {}
    },
    locationsIds () {
      if (this.locations) {
        return this.locations.map((loc) => { return loc.id })
      }
      return []
    },
    isValid () {
      if (!this.products) { return false }
      if (this.products.length === 0) { return false }
      if (this.locations && this.locations.length === 0) { return false }
      return true
    },
    payload () {
      if (this.products) {
        return {
          products: this.products.join(','),
          to_practitioner: this.practitionerId,
          to_space: this.spaceId,
          to_locations: this.locations
        }
      }
      return {}
    }
  }
}
</script>
